<style scoped>
    .id-card-img{
        max-width: 360px;
    }
</style>
<template>
    <div>
        <div class="line">
            <div>
                <span class="text-bold">身份证正面</span>
                <a :href="id_front_src" :download="id_front_name" v-if="id_front_src">下载</a>
            </div>
            <img class="id-card-img" :src="id_front_src" v-if="id_front_src">
            <span v-else>未上传</span>
        </div>
        <div class="line">
            <div>
                <span class="text-bold">身份证反面</span>
                <a :href="id_back_src" :download="id_back_name" v-if="id_back_src">下载</a>
            </div>
            <img class="id-card-img" :src="id_back_src" v-if="id_back_src">
            <span v-else>未上传</span>
        </div>
        <div class="line">
            <div>
                <span class="text-bold">学生证照片</span>
                <a :href="student_card_src" :download="student_card_name" v-if="student_card_src">下载</a>
            </div>
            <img class="id-card-img" :src="student_card_src" v-if="student_card_src">
            <span v-else>未上传</span>
        </div>
        <div class="line">
            <div>
                <span class="text-bold">银行卡照片</span>
                <a :href="bank_card_src" :download="bank_card_name" v-if="bank_card_src">下载</a>
            </div>
            <img class="id-card-img" :src="bank_card_src" v-if="bank_card_src">
            <span v-else>未上传</span>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: {
            pre_customer: {
                type: Object
            }
        },
        data(){
            return {
                //
            }
        },
        computed: {
            id_front_src(){
                return this.pre_customer.id_front ? Util.customerFileUrl(this.pre_customer.id_front) : '';
            },
            id_back_src(){
                return this.pre_customer.id_back ? Util.customerFileUrl(this.pre_customer.id_back) : '';
            },
            student_card_src(){
                return this.pre_customer.student_card ? Util.customerFileUrl(this.pre_customer.student_card) : '';
            },
            bank_card_src(){
                return this.pre_customer.bank_card ? Util.customerFileUrl(this.pre_customer.bank_card) : '';
            },
            id_front_name(){
                return `${this.pre_customer.account}_正面`;
            },
            id_back_name(){
                return `${this.pre_customer.account}_反面`;
            },
            student_card_name(){
                return `${this.pre_customer.account}_学生证照片`;
            },
            bank_card_name(){
                return `${this.pre_customer.account}_银行卡照片`;
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            test(){
                Util.ajax.get('api_url', {
                    params: {
                        //
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        //成功
                    }else{
                        //失败
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            }
        }
    }
</script>
